// import React, { useState } from "react";
// import { Link } from "react-router-dom";
// import CatalogueNavbar from "../../components/CatalogueNavbar";
// import FooterCatalogue from "../../components/FooterCatalogue";
// export default function ProductPage() {
//   // Product spec array start
//   const [openDropdownIndex, setOpenDropdownIndex] = useState(null);

//   const fabricData = [
//     {
//       iconUrl: "/icons_Products/Fabrics/FabricType.svg",
//       topic: "GSM",
//       contentArray: ["140 to 300"],
//     },
//     {
//       iconUrl: "/icons_Products/Fabrics/Size.svg",
//       topic: "Width",
//       contentArray: ["140 to 185 cm"],
//     },
//     {
//       iconUrl: "/icons_Products/Fabrics/MOQ.svg",
//       topic: "Minimum Order Quantity",
//       contentArray: ["30 kgs per colour],
//     },
//     {
//       iconUrl: "/icons_Products/Fabrics/Sample.svg",
//       topic: "Production Certifications",
//       contentArray: ["GOTS"],
//     },
//     {
//       iconUrl: "/icons_Products/Fabrics/OrderLead.svg",
//       topic: "Lab Dip Lead Time",
//       contentArray: ["10 to 20 working days."],
//     },
//     {
//       iconUrl: "/icons_Products/Fabrics/OrderLead.svg",
//       topic: "Order lead time",
//       contentArray: ["Order Basis"],
//     },
//     {
//       iconUrl: "/icons_Products/Fabrics/PPSample.svg",
//       topic: "PP Sample Lead Time",
//       contentArray: ["Order Basis"],
//     },
//     {
//       iconUrl: "/icons_Products/Fabrics/Sample.svg",
//       topic: "Sample making",
//       contentArray: ["Yes, available."],
//     },
//     {
//       iconUrl: "/icons_Products/Fabrics/Customize.svg",
//       topic: "Customization",
//       contentArray: ["Yes"],
//     },
//     {
//       iconUrl: "/icons_Products/Fabrics/Blends.svg",
//       topic: "Possible Blends",
//       contentArray: ["Cotton", "Cotton Lycra Blend", "Polyester Cotton Blend"],
//     },
//     {
//       iconUrl: "/icons_Products/Fabrics/BulkLead.svg",
//       topic: "Bulk Lead Time",
//       contentArray: ["Order Basis"],
//     },
//     {
//       iconUrl: "/icons_Products/Fabrics/Branding.svg",
//       topic: "Garments User for",
//       contentArray: ["T-shirts", "Cardigans", "Skirts"],
//     },
//   ];

//   const toggleDropdown = (index) => {
//     setOpenDropdownIndex(openDropdownIndex === index ? null : index);
//   };
//   // Product spec array end

//   // More about the fabric start
//   const array = [
//     {
//       Image: "/fabrics/Mercerized-Cotton-Knit-Fabric4.png",
//       Content: (
//         <div className="text-left text-lg flex flex-col">
//           <div className=" mb-1 text-[#242424]  font-semibold text-2xl">
//             A Look into the Fabric
//           </div>
//           <div className=" text-left mb-3 text-[#5B5B5B]">
//             LoopKnit fabric captivates with its unique, airy appearance and
//             intricately arranged open loops that form a dynamic, textured
//             surface. The open structure creates a light, breezy look with a
//             modern, relaxed vibe that redefines traditional knit aesthetics. Its
//             artistic interplay of loops produces a sculptural, contemporary
//             effect that appeals to creative design sensibilities. Ideal for
//             those who appreciate innovative style, LoopKnit offers both visual
//             intrigue and a tactile charm that sets garments apart. This fabric
//             reimagines knitwear by blending function with avant-garde artistry,
//             delivering an effortlessly cool aesthetic that enhances every
//             wardrobe with a distinctive, modern flair.
//           </div>
//         </div>
//       ),
//     },
//     {
//       Image: "/fabrics/Mercerized-Cotton-Knit-Fabric4.png",
//       Content: (
//         <div className="text-left text-lg flex flex-col">
//           <div className="mb-1  font-semibold text-2xl text-[#242424] ">
//             Properties of the Fabric
//           </div>
//           <div className=" text-left mb-3 text-[#5B5B5B]">
//             LoopKnit fabric is prized for its exceptional breathability,
//             lightweight feel, and distinctively textured surface. Its open loop
//             structure provides superior air circulation, making it an excellent
//             choice for warm climates and active lifestyles. The fabric drapes
//             comfortably while its tactile quality adds a unique, artistic
//             dimension. Durable yet delicate, LoopKnit balances functionality
//             with innovative design, ensuring garments retain their shape and
//             allure over time. Its versatility makes it ideal for both casual and
//             contemporary fashion, delivering a stylish look that is as
//             comfortable as it is distinctive. Embrace a fabric that stands for
//             modern design and lasting comfort.
//           </div>
//         </div>
//       ),
//     },
//     {
//       Image: "/fabrics/Knitting.jpg",
//       Content: (
//         <div className="text-left text-lg flex flex-col">
//           <div className=" mb-1 font-semibold text-2xl text-[#242424] ">
//             Knit Process of the Fabric
//           </div>
//           <div className=" text-left mb-3 text-[#5B5B5B]">
//             LoopKnit fabric is created through an innovative knitting process
//             that intentionally leaves open loops to produce its signature airy
//             design. Specialized machinery precisely controls loop spacing and
//             formation, ensuring a consistent yet distinctive texture. This
//             deliberate technique boosts breathability and lightweight comfort
//             while offering a striking, sculptural finish. Skilled technicians
//             monitor every production stage, fine-tuning tension and density to
//             achieve optimal performance. The result is a fabric that marries
//             modern technology with creative artistry, delivering an eye-catching
//             aesthetic and functional versatility. LoopKnit is truly an ideal
//             choice for contemporary garments that demand innovation and
//             effortless style.
//           </div>
//         </div>
//       ),
//     },
//     {
//       Image: "/fabrics/Mercerized-Cotton-Knit-Fabric4.png",
//       Content: (
//         <div className="text-left text-lg flex flex-col">
//           <div className="mb-1 font-semibold text-2xl text-[#242424] ">
//             Fabric Used in Various Garments
//           </div>
//           <div className=" text-left mb-3 text-[#5B5B5B]">
//             LoopKnit fabric is remarkably versatile, making it perfect for a
//             wide array of garment applications and innovative blends. Its airy,
//             textured appearance lends a modern, dynamic aesthetic to casual
//             wear, athletic apparel, and creative fashion pieces. Designers value
//             its excellent breathability and lightweight drape, ideal for summer
//             tops, dresses, and activewear. Often blended with cotton, polyester,
//             or spandex, LoopKnit enhances performance by adding dimension and
//             comfort. Its unique structure also serves as a stylish accent in
//             layered designs, delivering both functionality and artistic flair.
//             Embrace the future of knitwear with LoopKnit, where innovation meets
//             versatile design.
//           </div>
//         </div>
//       ),
//     },
//     // More items can be added here
//   ];
//   // More about the fabric end

//   // Fabric composition start
//   const contentArray = [
//     {
//       imageUrl:
//         "https://www.shutterstock.com/shutterstock/photos/2456036585/display_1500/stock-photo-medicine-development-laboratory-asian-female-scientist-using-microscope-analyzes-petri-dish-2456036585.jpg",
//       content: <p className="text-center">Description for Image 2</p>,
//     },
//     {
//       imageUrl:
//         "https://www.shutterstock.com/shutterstock/photos/2456036585/display_1500/stock-photo-medicine-development-laboratory-asian-female-scientist-using-microscope-analyzes-petri-dish-2456036585.jpg",
//       content: <p className="text-center">Description for Image 2</p>,
//     },
//     {
//       imageUrl:
//         "https://www.shutterstock.com/shutterstock/photos/2456036585/display_1500/stock-photo-medicine-development-laboratory-asian-female-scientist-using-microscope-analyzes-petri-dish-2456036585.jpg",
//       content: <p className="text-center">Description for Image 2</p>,
//     },
//     {
//       imageUrl:
//         "https://www.shutterstock.com/shutterstock/photos/2456036585/display_1500/stock-photo-medicine-development-laboratory-asian-female-scientist-using-microscope-analyzes-petri-dish-2456036585.jpg",
//       content: <p className="text-center">Description for Image 2</p>,
//     },
//   ];

//   // Fabric composition end

//   // Discover more start
//   const contentArray1 = [
//     {
//       imageUrl: "../../FabricCat/4.png",
//       content: <p className="text-center font-semibold">Jacquard</p>,
//       redirectUrl: "/Fabrics/Jacquard",
//     },
//     {
//       imageUrl: "../../FabricCat/18.png",
//       content: <p className="text-center font-semibold">Ottoman</p>,
//       redirectUrl: "/Fabrics/Ottoman",
//     },
//     {
//       imageUrl: "../../FabricCat/16.png",
//       content: <p className="text-center font-semibold">Waffle</p>,
//       redirectUrl: "/Fabrics/Waffle",
//     },
//     {
//       imageUrl: "../../FabricCat/Slub.jpg",
//       content: <p className="text-center font-semibold">SlubKnit</p>,
//       redirectUrl: "/Fabrics/SlubKnit",
//     },
//   ];
//   // Discover more end

//   return (
//     <div className="font-Manrope">
//       <CatalogueNavbar />
//       {/* Banner start */}
//       <div
//         className="h-[50vh] bg-cover bg-center relative"
//         style={{ backgroundImage: "url('/FabCatbanner.png')" }}
//       >
//         {/* Inner div positioned at the bottom left corner */}
//         <div className="absolute bottom-[7vh] md:bottom-[10vh] left-[5vh] md:left-[10vh] p-3 text-white text-4xl ">
//           {/* Inner content here */}
//           <p>
//             <span className="font-bold text-2xl md:text-5xl">
//               <a href="/Fabrics">Fabrics</a> .{" "}
//               <a href="/Fabrics/LoopKnit">LoopKnit</a>
//             </span>
//           </p>
//         </div>
//       </div>
//       {/* Banner end */}
//       <div className="p-10 ">
//         {/* Image Gallery start */}
//         <div className="relative h-auto  flex md:flex-row flex-col  ">
//           {/* Left Column (45% width) */}
//           <div className="hidden   md:block md:w-[45%]">
//             <ImageGallery />
//           </div>
//           <div className="block md:hidden md:w-[45%]">
//             <ImageGallery1 />
//           </div>
//           {/* Right Column (55% width) - content placeholder */}
//           <div className="w-full md:w-[55%] md:pt-0 pt-3 pl-0 md:pl-8 ">
//             <h2 className="text-xl font-semibold  mb-2">Loop Knit Fabric</h2>
//             <p className="text-sm text-[#666666]">
//               Loop knit fabric features a surface made entirely of continuous
//               loops, imparting a soft and tactile texture. This design enhances
//               the fabric’s cushioning and absorbency, making it well-suited for
//               comfortable loungewear, casual garments, and activewear that
//               benefits from extra softness.
//             </p>
//             <div className="mt-4 text-[#666666] flex flex-row">Color</div>
//             <div className="flex flex-row space-x-2 items-center">
//               <img src="/Colour.png" alt="" className="w-5 h-5" />
//               <span>Customizable to any Pantone colors.</span>
//             </div>
//             <div className="mt-4 text-black flex flex-col">
//               <div className="font-semibold">Our special finishes</div>
//               <div className="">
//                 Bio-Washed, Mercerized, Gold Finish (Soft hand feel), Water
//                 Repellent, Anti-Bacterial, Wicking, UV Protection, Flame
//                 Retardant, Anti-Static, Moisture Management, Stretch Recovery.
//               </div>
//             </div>
//             <div className="container mx-auto mt-6 md:mt-8">
//               <button className="w-full bg-transparent border-2 border-[#465B83] text-[#000000]  rounded-full">
//                 Get a sample Fabric
//               </button>
//             </div>
//           </div>
//         </div>
//         {/* Image Gallery end */}
//         {/* product spec start */}
//         <div className="mt-10  md:px-6 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3  font-brygada">
//           {fabricData.map((item, index) => (
//             <div
//               key={index}
//               className="flex flex-row items-center bg-white pl-0 pr-0 md:pl-4 md:pr-4 p-3  space-x-1 w-full"
//             >
//               <div className="flex-none  pr-2 ">
//                 <img
//                   src={item.iconUrl}
//                   alt={`${item.topic} Icon`}
//                   className="h-12 w-12"
//                 />
//               </div>
//               <div className="flex-grow   flex flex-col items-start justify-between">
//                 <div className="font-bold text-[#242424]">{item.topic}</div>
//                 {item.contentArray.length > 1 ? (
//                   <div className="relative w-full text-[#6B6B6B]">
//                     <button
//                       onClick={() => toggleDropdown(index)}
//                       className="text-black  mt-1 w-full flex flex-row text-left relative"
//                     >
//                       {item.contentArray[0]}
//                       <span className="relative ml-2 mt-1">
//                         <svg
//                           className="w-4 h-4 fill-current"
//                           viewBox="0 0 20 20"
//                         >
//                           <path d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" />
//                         </svg>
//                       </span>
//                     </button>
//                     {openDropdownIndex === index && (
//                       <ul className="origin-top absolute mt-1 w-full bg-white shadow-lg rounded-md overflow-hidden z-10">
//                         {item.contentArray.map((content, idx) => (
//                           <li
//                             key={idx}
//                             className="p-2 hover:bg-gray-100 cursor-pointer text-left"
//                           >
//                             {content}
//                           </li>
//                         ))}
//                       </ul>
//                     )}
//                   </div>
//                 ) : (
//                   <div className="mt-1 text-left w-full">
//                     {item.contentArray[0]}
//                   </div>
//                 )}
//               </div>
//             </div>
//           ))}
//         </div>

//         {/* Get in touch start */}
//         <div className="text-[#242424] hover:scale-110 text-xl font-semibold underline mt-6 mb-12 px-14">
//           <a href="/Catalogue#ContactUs">
//             Pls feel free to get in touch with our expert Fabric and Garment
//             consultants.
//           </a>
//         </div>
//         {/* Get in touch end */}
//         {/* product spec end */}
//         {/* Fabric composition/blends start */}
//         {/* <div className="mt-5 mb-2 font-brygada font-semibold text-[#242424] flex items-center justify-center text-2xl">
//           Our pique Knit compositions
//         </div>
//         <div className="text-[#757575] flex flex-col items-center justify-center mb-5 text-sm">
//           <div>
//             Discover our exceptional range of knit fabrics, perfect for quality
//             and style. For custom options,
//           </div>
//           <div className="text-[#242424] font-semibold underline">
//             <a href="/Catalogue#ContactUs">
//               Pls feel free to get in touch with our expert Fabric and Garment
//               consultants.
//             </a>
//           </div>
//         </div>

//         <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 p-4">
//           {contentArray.map((item, index) => (
//             <div key={index} className="flex flex-col items-center bg-white ">
//               <img
//                 src={item.imageUrl}
//                 alt={`Description ${index + 1}`}
//                 className=" w-[90%]  object-cover  rounded-lg h-[55vh]" // Ensuring the image covers the div and has rounded top corners
//               />
//               <div className="p-4">{item.content}</div>
//             </div>
//           ))}
//         </div> */}
//         {/* Fabric composition/blends end */}
//         {/* More about the fabric start */}
//         <div className="mt-10 mb-2 font-brygada font-semibold text-[#242424] flex items-center justify-center text-4xl">
//           Know more about the fabric
//         </div>
//         <div className="flex flex-wrap">
//           {array.map((item, index) => (
//             <React.Fragment key={index}>
//               {/* Determine column order based on index for larger screens */}
//               <div
//                 className={`w-full  md:flex md:mt-8 md:space-x-3 ${
//                   index % 2 === 0 ? "md:flex-row-reverse" : "md:flex-row"
//                 }`}
//               >
//                 {/* Image container */}
//                 <div className="w-full md:w-1/2 md:flex md:items-center md:justify-center ">
//                   <div className="relative w-[90%] h-[50vh]    ">
//                     <img
//                       src={item.Image}
//                       alt="Fabric"
//                       className="w-full h-full object-fit"
//                     />
//                   </div>
//                 </div>
//                 {/* Content container */}
//                 <div className="w-full  md:w-1/2 flex text-left pl-4 pr-4">
//                   {item.Content}
//                 </div>
//               </div>
//             </React.Fragment>
//           ))}
//         </div>

//         {/* More about the fabric end */}
//         {/* Discover more start */}
//         <div className="mt-10 mb-2 font-brygada font-semibold text-[#242424] flex items-center justify-center text-2xl">
//           Discover more Knitted Fabric Collections
//         </div>

//         <div className="w-full mt-8 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 p-4">
//           {contentArray1.map((item, index) => (
//             <a className="hover:scale-110" key={index} href={item.redirectUrl}>
//               <img
//                 src={item.imageUrl}
//                 alt={`Description ${index + 1}`}
//                 className="w-[90%] object-cover rounded-lg h-[55vh]"
//               />
//               <div className="p-4">{item.content}</div>
//             </a>
//           ))}
//         </div>
//         {/* Discover more end */}
//       </div>
//       <FooterCatalogue />
//     </div>
//   );
// }

// function ImageGallery() {
//   // Product showcase start
//   // Sample images
//   const images = [
//     "../../FabricCat/6.png",
//     // "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSqOVoASIrh9O0nBleaRqmP0ramt5YA74bFog&s",
//     // "https://media.istockphoto.com/id/2167996762/photo/flamingos-on-lake.jpg?s=612x612&w=0&k=20&c=avAsnt588cM2KjWah7F0M9-h17QhUzfJnOnpGlObQyk=",
//     // "https://media.istockphoto.com/id/2163630620/photo/abstract-minimalist-product-display-with-pink-smoke-and-wooden-branches.jpg?s=612x612&w=0&k=20&c=7xE-NrqmR5ZWFzqaVnB9xazub1L9Z-4PU5FZlCHvcyU=",
//     // "https://media.istockphoto.com/id/2171497774/photo/floating-bubbles-from-the-portal.jpg?s=612x612&w=0&k=20&c=SxnXY6XXftdTaAK-NSm6YSGnf7uEXhk8VcqDBgfWC6Y=",
//   ];

//   const [selectedIndex, setSelectedIndex] = useState(0);
//   const [startIndex, setStartIndex] = useState(0);
//   const THUMBNAILS_PER_VIEW = 3;

//   const handlePrev = () => {
//     if (startIndex > 0) {
//       setStartIndex((prev) => prev - 1);
//     }
//   };

//   const handleNext = () => {
//     if (startIndex + THUMBNAILS_PER_VIEW < images.length) {
//       setStartIndex((prev) => prev + 1);
//     }
//   };

//   // Check if there are 3 or fewer images
//   const isThreeOrFewerImages = images.length <= 3;

//   // Product showcase end

//   return (
//     <div className="h-full">
//       <div className="flex h-full">
//         {/* Thumbnail Column (Left side) */}
//         <div className="flex flex-col items-center  pl-6 pr-4 h-full">
//           {/* Up Arrow */}
//           {!isThreeOrFewerImages && (
//             <button
//               onClick={handlePrev}
//               disabled={startIndex === 0}
//               className="disabled:opacity-50"
//             >
//               {/* &#9650;  */}
//               <svg
//                 xmlns="http://www.w3.org/2000/svg"
//                 width="24"
//                 height="24"
//                 viewBox="0 0 24 24"
//                 fill="none"
//                 stroke="currentColor"
//                 stroke-width="2"
//                 stroke-linecap="round"
//                 stroke-linejoin="round"
//               >
//                 <path d="M18 15l-6-6-6 6" />
//               </svg>
//             </button>
//           )}

//           {/* Thumbnails */}
//           <div
//             className={`flex flex-col overflow-hidden ${
//               isThreeOrFewerImages ? "justify-center h-[95%]" : "h-[95%]"
//             }`}
//           >
//             {images
//               .slice(startIndex, startIndex + THUMBNAILS_PER_VIEW)
//               .map((imgUrl, i) => {
//                 const actualIndex = startIndex + i;
//                 return (
//                   <img
//                     key={imgUrl}
//                     src={imgUrl}
//                     alt={`Thumbnail ${i}`}
//                     onClick={() => setSelectedIndex(actualIndex)}
//                     className={`w-20 h-20 object-cover cursor-pointer  mb-2 rounded-xl border
//                   ${
//                     selectedIndex === actualIndex
//                       ? "border-blue-500"
//                       : "border-transparent"
//                   }
//                 `}
//                   />
//                 );
//               })}
//           </div>

//           {/* Down Arrow */}
//           {!isThreeOrFewerImages && (
//             <button
//               onClick={handleNext}
//               disabled={startIndex + THUMBNAILS_PER_VIEW >= images.length}
//               className=" disabled:opacity-50"
//             >
//               {/* &#9660;  */}
//               <svg
//                 xmlns="http://www.w3.org/2000/svg"
//                 width="24"
//                 height="24"
//                 viewBox="0 0 24 24"
//                 fill="none"
//                 stroke="currentColor"
//                 stroke-width="2"
//                 stroke-linecap="round"
//                 stroke-linejoin="round"
//               >
//                 <path d="M6 9l6 6 6-6" />
//               </svg>
//             </button>
//           )}
//         </div>

//         {/* Main Image */}
//         <div className="flex-1 h-[65vh]">
//           <img
//             src={images[selectedIndex]}
//             alt="Selected main"
//             className="w-full h-full object-cover rounded-md shadow-md"
//           />
//         </div>
//       </div>
//     </div>
//   );
// }

// function ImageGallery1() {
//   // Sample images
//   const images = [
//     "../../FabricCat/6.png",
//     // "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSqOVoASIrh9O0nBleaRqmP0ramt5YA74bFog&s",
//     // "https://media.istockphoto.com/id/2167996762/photo/flamingos-on-lake.jpg?s=612x612&w=0&k=20&c=avAsnt588cM2KjWah7F0M9-h17QhUzfJnOnpGlObQyk=",
//     // "https://media.istockphoto.com/id/2163630620/photo/abstract-minimalist-product-display-with-pink-smoke-and-wooden-branches.jpg?s=612x612&w=0&k=20&c=7xE-NrqmR5ZWFzqaVnB9xazub1L9Z-4PU5FZlCHvcyU=",
//     // "https://media.istockphoto.com/id/2171497774/photo/floating-bubbles-from-the-portal.jpg?s=612x612&w=0&k=20&c=SxnXY6XXftdTaAK-NSm6YSGnf7uEXhk8VcqDBgfWC6Y=",
//   ];

//   const [selectedIndex, setSelectedIndex] = useState(0);
//   const [startIndex, setStartIndex] = useState(0);
//   const THUMBNAILS_PER_VIEW = 4;

//   const handlePrev = () => {
//     if (startIndex > 0) {
//       setStartIndex((prev) => prev - 1);
//     }
//   };

//   const handleNext = () => {
//     if (startIndex + THUMBNAILS_PER_VIEW < images.length) {
//       setStartIndex((prev) => prev + 1);
//     }
//   };

//   // Check if there are more thumbnails to scroll
//   const hasMoreThumbnails = images.length > THUMBNAILS_PER_VIEW;

//   // Check if the left arrow is active
//   const isLeftArrowActive = startIndex > 0;
//   // Check if the right arrow is active
//   const isRightArrowActive = startIndex + THUMBNAILS_PER_VIEW < images.length;

//   return (
//     <div className="h-[65vh] w-full">
//       <div className="flex flex-col h-full w-full">
//         {/* Main Image */}
//         <div className="flex-1 h-[70%] w-full mb-4">
//           <img
//             src={images[selectedIndex]}
//             alt="Selected main"
//             className="w-full h-full object-cover rounded-md shadow-md"
//           />
//         </div>

//         {/* Thumbnail Row (Horizontal) */}
//         <div className="flex items-center justify-center mt-4 w-full h-[10vh] relative">
//           {/* Left Arrow */}
//           {hasMoreThumbnails && (
//             <button
//               onClick={handlePrev}
//               disabled={!isLeftArrowActive}
//               className={`absolute left-0 z-10 ${
//                 isLeftArrowActive ? "text-black" : "text-gray-400"
//               }`}
//               style={{ width: "5%" }}
//             >
//               {/* &#9664;  */}
//               <svg
//                 xmlns="http://www.w3.org/2000/svg"
//                 width="20"
//                 height="20"
//                 viewBox="0 0 24 24"
//                 fill="none"
//                 stroke="currentColor"
//                 stroke-width="2"
//                 stroke-linecap="round"
//                 stroke-linejoin="round"
//               >
//                 <path d="M15 18l-6-6 6-6" />
//               </svg>
//             </button>
//           )}

//           {/* Thumbnails */}
//           <div
//             className="flex items-center justify-start overflow-x-hidden w-[90%] mx-auto"
//             style={{
//               scrollBehavior: "smooth",
//             }}
//           >
//             {images
//               .slice(startIndex, startIndex + THUMBNAILS_PER_VIEW)
//               .map((imgUrl, i) => {
//                 const actualIndex = startIndex + i;
//                 return (
//                   <img
//                     key={imgUrl}
//                     src={imgUrl}
//                     alt={`Thumbnail ${i}`}
//                     onClick={() => setSelectedIndex(actualIndex)}
//                     className={`ml-2 w-1/4 h-12 object-cover cursor-pointer mx-1 rounded-xl border
//                   ${
//                     selectedIndex === actualIndex
//                       ? "border-blue-500"
//                       : "border-transparent"
//                   }
//                 `}
//                   />
//                 );
//               })}
//           </div>

//           {/* Right Arrow */}
//           {hasMoreThumbnails && (
//             <button
//               onClick={handleNext}
//               disabled={!isRightArrowActive}
//               className={`ml-3 absolute right-0 z-10 ${
//                 isRightArrowActive ? "text-black" : "text-gray-400"
//               }`}
//               style={{ width: "5%" }}
//             >
//               {/* &#10145;  */}
//               <svg
//                 xmlns="http://www.w3.org/2000/svg"
//                 width="20"
//                 height="20"
//                 viewBox="0 0 24 24"
//                 fill="none"
//                 stroke="currentColor"
//                 stroke-width="2"
//                 stroke-linecap="round"
//                 stroke-linejoin="round"
//               >
//                 <path d="M9 18l6-6-6-6" />
//               </svg>
//             </button>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// }

import React, { useState } from "react";
import { Link } from "react-router-dom";
import CatalogueNavbar from "../../components/CatalogueNavbar";
import FooterCatalogue from "../../components/FooterCatalogue";

export default function ProductPage() {
  // Product spec array start
  const [openDropdownIndex, setOpenDropdownIndex] = useState(null);

  const fabricData = [
    {
      iconUrl: "/icons_Products/Fabrics/FabricType.svg",
      topic: "GSM",
      contentArray: ["140 to 300"],
    },
    {
      iconUrl: "/icons_Products/Fabrics/Size.svg",
      topic: "Width",
      contentArray: ["140 to 185 cm"],
    },
    {
      iconUrl: "/icons_Products/Fabrics/MOQ.svg",
      topic: "Minimum Order Quantity",
      contentArray: ["30 kgs per colour"],
    },
    {
      iconUrl: "/icons_Products/Fabrics/Sample.svg",
      topic: "Production Certifications",
      contentArray: ["GOTS"],
    },
    {
      iconUrl: "/icons_Products/Fabrics/OrderLead.svg",
      topic: "Lab Dip Lead Time",
      contentArray: ["10 to 20 working days."],
    },
    {
      iconUrl: "/icons_Products/Fabrics/OrderLead.svg",
      topic: "Order lead time",
      contentArray: ["Order Basis"],
    },
    {
      iconUrl: "/icons_Products/Fabrics/PPSample.svg",
      topic: "PP Sample Lead Time",
      contentArray: ["Order Basis"],
    },
    {
      iconUrl: "/icons_Products/Fabrics/Sample.svg",
      topic: "Sample making",
      contentArray: ["Yes, available."],
    },
    {
      iconUrl: "/icons_Products/Fabrics/Customize.svg",
      topic: "Customization",
      contentArray: ["Yes"],
    },
    {
      iconUrl: "/icons_Products/Fabrics/Blends.svg",
      topic: "Possible Blends",
      contentArray: ["Cotton", "Cotton Lycra Blend", "Polyester Cotton Blend"],
    },
    {
      iconUrl: "/icons_Products/Fabrics/BulkLead.svg",
      topic: "Bulk Lead Time",
      contentArray: ["Order Basis"],
    },
    {
      iconUrl: "/icons_Products/Fabrics/Branding.svg",
      topic: "Garments User for",
      contentArray: ["T-shirts", "Cardigans", "Skirts"],
    },
  ];

  const toggleDropdown = (index) => {
    setOpenDropdownIndex(openDropdownIndex === index ? null : index);
  };
  // Product spec array end

  // More about the fabric start
  const array = [
    {
      Image: "../../FabricCat/6.png",
      Content: (
        <div className="text-left text-lg flex flex-col">
          <div className=" mb-1 text-[#242424]  font-semibold text-2xl">
            A Look into the Fabric
          </div>
          <div className=" text-left mb-3 text-[#5B5B5B]">
            LoopKnit fabric captivates with its unique, airy appearance and
            intricately arranged open loops that form a dynamic, textured
            surface. The open structure creates a light, breezy look with a
            modern, relaxed vibe that redefines traditional knit aesthetics. Its
            artistic interplay of loops produces a sculptural, contemporary
            effect that appeals to creative design sensibilities. Ideal for
            those who appreciate innovative style, LoopKnit offers both visual
            intrigue and a tactile charm that sets garments apart. This fabric
            reimagines knitwear by blending function with avant-garde artistry,
            delivering an effortlessly cool aesthetic that enhances every
            wardrobe with a distinctive, modern flair.
          </div>
        </div>
      ),
    },
    {
      Image: "../../FabricCat/6.png",
      Content: (
        <div className="text-left text-lg flex flex-col">
          <div className="mb-1  font-semibold text-2xl text-[#242424] ">
            Properties of the Fabric
          </div>
          <div className=" text-left mb-3 text-[#5B5B5B]">
            LoopKnit fabric is prized for its exceptional breathability,
            lightweight feel, and distinctively textured surface. Its open loop
            structure provides superior air circulation, making it an excellent
            choice for warm climates and active lifestyles. The fabric drapes
            comfortably while its tactile quality adds a unique, artistic
            dimension. Durable yet delicate, LoopKnit balances functionality
            with innovative design, ensuring garments retain their shape and
            allure over time. Its versatility makes it ideal for both casual and
            contemporary fashion, delivering a stylish look that is as
            comfortable as it is distinctive. Embrace a fabric that stands for
            modern design and lasting comfort.
          </div>
        </div>
      ),
    },
    {
      Image: "/fabrics/Knitting.jpg",
      Content: (
        <div className="text-left text-lg flex flex-col">
          <div className=" mb-1 font-semibold text-2xl text-[#242424] ">
            Knit Process of the Fabric
          </div>
          <div className=" text-left mb-3 text-[#5B5B5B]">
            LoopKnit fabric is created through an innovative knitting process
            that intentionally leaves open loops to produce its signature airy
            design. Specialized machinery precisely controls loop spacing and
            formation, ensuring a consistent yet distinctive texture. This
            deliberate technique boosts breathability and lightweight comfort
            while offering a striking, sculptural finish. Skilled technicians
            monitor every production stage, fine-tuning tension and density to
            achieve optimal performance. The result is a fabric that marries
            modern technology with creative artistry, delivering an eye-catching
            aesthetic and functional versatility. LoopKnit is truly an ideal
            choice for contemporary garments that demand innovation and
            effortless style.
          </div>
        </div>
      ),
    },
    {
      Image: "../../FabricCat/6.png",
      Content: (
        <div className="text-left text-lg flex flex-col">
          <div className="mb-1 font-semibold text-2xl text-[#242424] ">
            Fabric Used in Various Garments
          </div>
          <div className=" text-left mb-3 text-[#5B5B5B]">
            LoopKnit fabric is remarkably versatile, making it perfect for a
            wide array of garment applications and innovative blends. Its airy,
            textured appearance lends a modern, dynamic aesthetic to casual
            wear, athletic apparel, and creative fashion pieces. Designers value
            its excellent breathability and lightweight drape, ideal for summer
            tops, dresses, and activewear. Often blended with cotton, polyester,
            or spandex, LoopKnit enhances performance by adding dimension and
            comfort. Its unique structure also serves as a stylish accent in
            layered designs, delivering both functionality and artistic flair.
            Embrace the future of knitwear with LoopKnit, where innovation meets
            versatile design.
          </div>
        </div>
      ),
    },
  ];
  // More about the fabric end

  // Fabric composition start
  const contentArray = [
    {
      imageUrl:
        "https://www.shutterstock.com/shutterstock/photos/2456036585/display_1500/stock-photo-medicine-development-laboratory-asian-female-scientist-using-microscope-analyzes-petri-dish-2456036585.jpg",
      content: <p className="text-center">Description for Image 2</p>,
    },
    {
      imageUrl:
        "https://www.shutterstock.com/shutterstock/photos/2456036585/display_1500/stock-photo-medicine-development-laboratory-asian-female-scientist-using-microscope-analyzes-petri-dish-2456036585.jpg",
      content: <p className="text-center">Description for Image 2</p>,
    },
    {
      imageUrl:
        "https://www.shutterstock.com/shutterstock/photos/2456036585/display_1500/stock-photo-medicine-development-laboratory-asian-female-scientist-using-microscope-analyzes-petri-dish-2456036585.jpg",
      content: <p className="text-center">Description for Image 2</p>,
    },
    {
      imageUrl:
        "https://www.shutterstock.com/shutterstock/photos/2456036585/display_1500/stock-photo-medicine-development-laboratory-asian-female-scientist-using-microscope-analyzes-petri-dish-2456036585.jpg",
      content: <p className="text-center">Description for Image 2</p>,
    },
  ];
  // Fabric composition end

  // Discover more start
  const contentArray1 = [
    {
      imageUrl: "../../FabricCat/4.png",
      content: <p className="text-center font-semibold">Jacquard</p>,
      redirectUrl: "/Fabrics/Jacquard",
    },
    {
      imageUrl: "../../FabricCat/18.png",
      content: <p className="text-center font-semibold">Ottoman</p>,
      redirectUrl: "/Fabrics/Ottoman",
    },
    {
      imageUrl: "../../FabricCat/16.png",
      content: <p className="text-center font-semibold">Waffle</p>,
      redirectUrl: "/Fabrics/Waffle",
    },
    {
      imageUrl: "../../FabricCat/Slub.jpg",
      content: <p className="text-center font-semibold">SlubKnit</p>,
      redirectUrl: "/Fabrics/SlubKnit",
    },
  ];
  // Discover more end

  return (
    <div className="font-Manrope">
      <CatalogueNavbar />
      {/* Banner start */}
      <div
        className="h-[20vh] md:h-[50vh] bg-cover bg-center relative"
        style={{ backgroundImage: "url('/FabCatbanner.png')" }}
      >
        {/* Inner div positioned at the bottom left corner */}
        <div className="absolute bottom-[2vh] md:bottom-[10vh] left-[2vh] md:left-[10vh] p-3 text-white text-4xl ">
          {/* Inner content here */}
          <p>
            <span className="font-bold text-2xl md:text-5xl">
              <a href="/Fabrics">Fabrics</a> .{" "}
              <a href="/Fabrics/LoopKnit">LoopKnit</a>
            </span>
          </p>
        </div>
      </div>
      {/* Banner end */}
      <div className="p-10 ">
        {/* Image Gallery start */}
        <div className="relative h-auto  flex md:flex-row flex-col  ">
          {/* Left Column (45% width) */}
          <div className="hidden   md:block md:w-[45%]">
            <ImageGallery />
          </div>
          <div className="block md:hidden md:w-[45%]">
            <ImageGallery1 />
          </div>
          {/* Right Column (55% width) - content placeholder */}
          <div className="w-full md:w-[55%] md:pt-0 -mt-24 md:-mt-0 pl-0 md:pl-8 ">
            <h2 className="text-xl font-semibold  mb-2">Loop Knit Fabric</h2>
            <p className="text-sm text-[#666666]">
              Loop knit fabric features a surface made entirely of continuous
              loops, imparting a soft and tactile texture. This design enhances
              the fabric’s cushioning and absorbency, making it well-suited for
              comfortable loungewear, casual garments, and activewear that
              benefits from extra softness.
            </p>
            <div className="mt-4 text-[#666666] flex flex-row">Color</div>
            <div className="flex flex-row space-x-2 items-center">
              <img src="/Colour.png" alt="" className="w-5 h-5" />
              <span>Customizable to any Pantone colors.</span>
            </div>
            <div className="mt-4 text-black flex flex-col">
              <div className="font-semibold">Our special finishes</div>
              <div className="">
                Bio-Washed, Mercerized, Gold Finish (Soft hand feel), Water
                Repellent, Anti-Bacterial, Wicking, UV Protection, Flame
                Retardant, Anti-Static, Moisture Management, Stretch Recovery.
              </div>
            </div>
            <div className="container mx-auto mt-6 md:mt-8">
              <button className="w-full bg-transparent border-2 border-[#465B83] text-[#000000]  rounded-full">
                Get a sample Fabric
              </button>
            </div>
          </div>
        </div>
        {/* Image Gallery end */}
        {/* product spec start */}
        <div className="mt-10  md:px-6 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3  font-brygada">
          {fabricData.map((item, index) => (
            <div
              key={index}
              className="flex flex-row items-center bg-white pl-0 pr-0 md:pl-4 md:pr-4 p-3  space-x-1 w-full"
            >
              <div className="flex-none  pr-2 ">
                <img
                  src={item.iconUrl}
                  alt={`${item.topic} Icon`}
                  className="h-12 w-12"
                />
              </div>
              <div className="flex-grow   flex flex-col items-start justify-between">
                <div className="font-bold text-[#242424]">{item.topic}</div>
                {item.contentArray.length > 1 ? (
                  <div className="relative w-full text-[#6B6B6B]">
                    <button
                      onClick={() => toggleDropdown(index)}
                      className="text-black  mt-1 w-full flex flex-row text-left relative"
                    >
                      {item.contentArray[0]}
                      <span className="relative ml-2 mt-1">
                        <svg
                          className="w-4 h-4 fill-current"
                          viewBox="0 0 20 20"
                        >
                          <path d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" />
                        </svg>
                      </span>
                    </button>
                    {openDropdownIndex === index && (
                      <ul className="origin-top absolute mt-1 w-full bg-white shadow-lg rounded-md overflow-hidden z-10">
                        {item.contentArray.map((content, idx) => (
                          <li
                            key={idx}
                            className="p-2 hover:bg-gray-100 cursor-pointer text-left"
                          >
                            {content}
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                ) : (
                  <div className="mt-1 text-left w-full">
                    {item.contentArray[0]}
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>

        {/* Get in touch start */}
        <div className="text-[#242424] hover:scale-110 text-xl font-semibold underline mt-6 mb-12 md:px-14">
          <a href="/Catalogue#ContactUs">
            Pls feel free to get in touch with our expert Fabric and Garment
            consultants.
          </a>
        </div>
        {/* Get in touch end */}
        {/* product spec end */}
        {/* Fabric composition/blends start */}
        {/* Commented out section preserved from first code */}
        {/* <div className="mt-5 mb-2 font-brygada font-semibold text-[#242424] flex items-center justify-center text-2xl">
          Our pique Knit compositions
        </div>
        <div className="text-[#757575] flex flex-col items-center justify-center mb-5 text-sm">
          <div>
            Discover our exceptional range of knit fabrics, perfect for quality
            and style. For custom options,
          </div>
          <div className="text-[#242424] font-semibold underline">
            <a href="/Catalogue#ContactUs">
              Pls feel free to get in touch with our expert Fabric and Garment
              consultants.
            </a>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 p-4">
          {contentArray.map((item, index) => (
            <div key={index} className="flex flex-col items-center bg-white ">
              <img
                src={item.imageUrl}
                alt={`Description ${index + 1}`}
                className=" w-[90%]  object-cover  rounded-lg h-[55vh]"
              />
              <div className="p-4">{item.content}</div>
            </div>
          ))}
        </div> */}
        {/* Fabric composition/blends end */}
        {/* More about the fabric start */}
        <div className="mt-10 mb-2 font-brygada font-semibold text-[#242424] flex items-center justify-center text-4xl">
          Know more about the fabric
        </div>
        <div className="flex flex-wrap   mt-6 md:mt-0">
          {array.map((item, index) => (
            <React.Fragment key={index}>
              {/* Determine column order based on index for larger screens */}
              <div
                className={`w-full  md:flex md:mt-8 space-y-6 md:space-y-0 md:space-x-3 ${
                  index % 2 === 0 ? "md:flex-row-reverse" : "md:flex-row"
                }`}
              >
                {/* Image container */}
                <div className="w-full mt-6 md:mt-0 md:w-1/2 md:flex md:items-center md:justify-center ">
                  <div className="relative w-full md:w-[90%] h-[30vh] md:h-[50vh]    ">
                    <img
                      src={item.Image}
                      alt="Fabric"
                      className="w-full h-full object-fit"
                    />
                  </div>
                </div>
                {/* Content container */}
                <div className="w-full  md:w-1/2 flex text-left pl-0 pr-0 md:pl-4 md:pr-4">
                  {item.Content}
                </div>
              </div>
            </React.Fragment>
          ))}
        </div>

        {/* More about the fabric end */}
        {/* Discover more start */}
        <div className="mt-10 mb-2 font-brygada font-semibold text-[#242424] flex items-center justify-center text-2xl">
          Discover more Knitted Fabric Collections
        </div>

        <div className="w-full  mt-8 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:p-4">
          {contentArray1.map((item, index) => (
            <a className="hover:scale-110 " key={index} href={item.redirectUrl}>
              <img
                src={item.imageUrl}
                alt={`Description ${index + 1}`}
                className="w-full md:w-[90%] mx-auto  object-cover rounded-lg h-[35vh] md:h-[55vh]"
              />
              <div className="p-2 md:p-4">{item.content}</div>
            </a>
          ))}
        </div>
        {/* Discover more end */}
      </div>
      <FooterCatalogue />
    </div>
  );
}

function ImageGallery() {
  // Product showcase start
  const images = ["../../FabricCat/6.png"];

  const [selectedIndex, setSelectedIndex] = useState(0);
  const [startIndex, setStartIndex] = useState(0);
  const THUMBNAILS_PER_VIEW = 3;

  const handlePrev = () => {
    if (startIndex > 0) {
      setStartIndex((prev) => prev - 1);
    }
  };

  const handleNext = () => {
    if (startIndex + THUMBNAILS_PER_VIEW < images.length) {
      setStartIndex((prev) => prev + 1);
    }
  };

  const isThreeOrFewerImages = images.length <= 3;

  // Product showcase end

  return (
    <div className="h-full">
      <div className="flex h-full">
        {/* Thumbnail Column (Left side) */}
        <div className="flex flex-col items-center  pl-6 pr-4 h-full">
          {/* Up Arrow */}
          {!isThreeOrFewerImages && (
            <button
              onClick={handlePrev}
              disabled={startIndex === 0}
              className="disabled:opacity-50"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path d="M18 15l-6-6-6 6" />
              </svg>
            </button>
          )}

          {/* Thumbnails */}
          <div
            className={`flex flex-col overflow-hidden ${
              isThreeOrFewerImages ? "justify-center h-[95%]" : "h-[95%]"
            }`}
          >
            {images
              .slice(startIndex, startIndex + THUMBNAILS_PER_VIEW)
              .map((imgUrl, i) => {
                const actualIndex = startIndex + i;
                return (
                  <img
                    key={imgUrl}
                    src={imgUrl}
                    alt={`Thumbnail ${i}`}
                    onClick={() => setSelectedIndex(actualIndex)}
                    className={`w-20 h-20 object-cover cursor-pointer  mb-2 rounded-xl border 
                  ${
                    selectedIndex === actualIndex
                      ? "border-blue-500"
                      : "border-transparent"
                  }
                `}
                  />
                );
              })}
          </div>

          {/* Down Arrow */}
          {!isThreeOrFewerImages && (
            <button
              onClick={handleNext}
              disabled={startIndex + THUMBNAILS_PER_VIEW >= images.length}
              className=" disabled:opacity-50"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path d="M6 9l6 6 6-6" />
              </svg>
            </button>
          )}
        </div>

        {/* Main Image */}
        <div className="flex-1 h-[65vh]">
          <img
            src={images[selectedIndex]}
            alt="Selected main"
            className="w-full h-full object-cover rounded-md shadow-md"
          />
        </div>
      </div>
    </div>
  );
}

function ImageGallery1() {
  const images = ["../../FabricCat/6.png"];

  const [selectedIndex, setSelectedIndex] = useState(0);
  const [startIndex, setStartIndex] = useState(0);
  const THUMBNAILS_PER_VIEW = 4;

  const handlePrev = () => {
    if (startIndex > 0) {
      setStartIndex((prev) => prev - 1);
    }
  };

  const handleNext = () => {
    if (startIndex + THUMBNAILS_PER_VIEW < images.length) {
      setStartIndex((prev) => prev + 1);
    }
  };

  const hasMoreThumbnails = images.length > THUMBNAILS_PER_VIEW;
  const isLeftArrowActive = startIndex > 0;
  const isRightArrowActive = startIndex + THUMBNAILS_PER_VIEW < images.length;

  return (
    <div className="h-[65vh] w-full">
      <div className="flex flex-col h-[50vh] w-full">
        {/* Main Image */}
        <div className="flex-1 h-[50%] w-full mb-0 md:mb-4">
          <img
            src={images[selectedIndex]}
            alt="Selected main"
            className="w-full h-full object-cover rounded-md shadow-md"
          />
        </div>

        {/* Thumbnail Row (Horizontal) */}
        <div className="flex items-center justify-center mt-0 md:mt-4  w-full h-[10vh] relative">
          {/* Left Arrow */}
          {hasMoreThumbnails && (
            <button
              onClick={handlePrev}
              disabled={!isLeftArrowActive}
              className={`absolute left-0 z-10 ${
                isLeftArrowActive ? "text-black" : "text-gray-400"
              }`}
              style={{ width: "5%" }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path d="M15 18l-6-6 6-6" />
              </svg>
            </button>
          )}

          {/* Thumbnails */}
          <div
            className="flex items-center justify-start overflow-x-hidden w-[90%] mx-auto"
            style={{
              scrollBehavior: "smooth",
            }}
          >
            {images
              .slice(startIndex, startIndex + THUMBNAILS_PER_VIEW)
              .map((imgUrl, i) => {
                const actualIndex = startIndex + i;
                return (
                  <img
                    key={imgUrl}
                    src={imgUrl}
                    alt={`Thumbnail ${i}`}
                    onClick={() => setSelectedIndex(actualIndex)}
                    className={`ml-2 w-1/4 h-12 object-cover cursor-pointer mx-1 rounded-xl border 
                  ${
                    selectedIndex === actualIndex
                      ? "border-blue-500"
                      : "border-transparent"
                  }
                `}
                  />
                );
              })}
          </div>

          {/* Right Arrow */}
          {hasMoreThumbnails && (
            <button
              onClick={handleNext}
              disabled={!isRightArrowActive}
              className={`ml-3 absolute right-0 z-10 ${
                isRightArrowActive ? "text-black" : "text-gray-400"
              }`}
              style={{ width: "5%" }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path d="M9 18l6-6-6-6" />
              </svg>
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
